import React from "react";
import { PRICING_PAGE_URL } from "@features/fundamentals/constants";
import { ComparisonBaseChart, ComparisonBaseChartProps } from "@components";
import { OnlyForProBlock } from "./components/OnlyForProBlock";

export const ComparisonBlurChart = (props: ComparisonBaseChartProps) => {
  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          filter: "blur(10px)",
          opacity: "0.5",
        }}
      >
        {props.data && props.data.length > 0 && (
          <ComparisonBaseChart {...props} />
        )}
      </div>
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <OnlyForProBlock href={PRICING_PAGE_URL} />
      </div>
    </div>
  );
};
